<template>
  <CCard class="mb-3">
    <CCardHeader>Rendimiento por hora</CCardHeader>
    <CCardBody>
      <apexchart
        type="bar"
        height="300"
        :options="chartOptions"
        :series="chartSeries"
      />
    </CCardBody>
  </CCard>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'HourlyPerformanceChart',
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    metric: {
      type: String,
      default: 'read_rate',
    },
  },
  computed: {
    selectedMetricLabel() {
      const map = {
        read_rate: 'Lectura',
        response_rate: 'Respuesta',
        delivery_rate: 'Entrega',
        error_rate: 'Error',
      }
      return map[this.metric] || 'Lectura'
    },
    categories() {
      return this.rows.map(function (row) {
        return row.hour_label || '--:--'
      })
    },
    values() {
      const metric = this.metric
      return this.rows.map(function (row) {
        return Number(row && row[metric] ? row[metric] : 0) * 100
      })
    },
    chartSeries() {
      return [
        {
          name: this.selectedMetricLabel,
          data: this.values,
        },
      ]
    },
    chartOptions() {
      return {
        chart: {
          toolbar: { show: false },
          foreColor: '#5c5648',
        },
        colors: ['#929C8B'],
        plotOptions: {
          bar: {
            borderRadius: 4,
            columnWidth: '65%',
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: this.categories,
          labels: {
            rotate: -45,
          },
        },
        yaxis: {
          max: 100,
          labels: {
            formatter: function (value) {
              return value.toFixed(0) + '%'
            },
          },
        },
        tooltip: {
          y: {
            formatter: function (value) {
              return value.toFixed(1) + '%'
            },
          },
        },
        grid: {
          borderColor: '#ece7d8',
        },
      }
    },
  },
}
</script>
